module.exports = __webpack_public_path__ + "static/media/8.6d9646c0.png";